import React from "react";
import { Typography, Button, Grid2 } from "@mui/material";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <Grid2 sx={{ textAlign: "center", m: 4 }}>
      <Typography variant="h4" sx={{ mt: 4 }}>
        Trainer App
      </Typography>
      <Typography sx={{ mt: 4, mb: 4, "line-height": "34px" }}>
        A remote fitness coaching platform focused on strength building fitness
        instruction. Built for powerlifting, weightlifting and general strength
        training coaching and instruction.{" "}
      </Typography>
      <Button
        variant="contained"
        component={Link}
        to="/coaching"
        sx={{ mt: 2 }}
      >
        Sign Up as a Coach
      </Button>
    </Grid2>
  );
};

export default Home;
